/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MessageTypeDTO = {
    INFO: 'INFO',
    WARNING: 'WARNING',
    ERROR: 'ERROR'
} as const;
export type MessageTypeDTO = typeof MessageTypeDTO[keyof typeof MessageTypeDTO];

